// extracted by mini-css-extract-plugin
export default {"Wrapper":"App_Wrapper__z7syU","Header":"App_Header__Xhto5","Title":"App_Title__NbD9D","Content":"App_Content__9goiP"};